export default "__VITE_ASSET__CYi67iB0__"